import React, { Component } from 'react';

import WelcomeJSON from "../../api/Welcome.json"
import './Welcome.scss';

class Welcome extends Component {
    renderLine(line) {
        return (
            <div className={line}
                dangerouslySetInnerHTML={{ __html: WelcomeJSON[line] }}></div>
        )
    }
    render() {
        return (
            <section className="section section-welcome">
                <div className="padding">
                    <div className="container">
                        <div className="welcometext">
                            {this.renderLine("line1")}
                            {this.renderLine("line2")}
                            {this.renderLine("line3")}
                            {this.renderLine("line4")}
                            {this.renderLine("line5")}
                        </div>
                        {/* <div className="special">
                            <div className="button"></div>
                        </div> */}
                    </div>
                </div>
            </section>
        );
    }
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/Components/Welcome/Welcome.jsx